import classNames from 'classnames'
import * as React from 'react'

import type {KeyValue} from '../../../../../../utils/object'
import {InactiveSidebarLink} from '../../../../../common/Sidebar/SidebarLink/SidebarLink'
import type {AgentsTreeItemPool} from '../../../AgentsSidebar/AgentsSidebar.types'
import styles from '../../../AgentsSidebar/AgentsSidebarItem/AgentPool/AgentPool.css'
import MatchingItem from '../../../components/MatchingItem/MatchingItem'
import {AgentPoolFavoriteStar} from '../../Star/AgentPoolFavoriteStar'

type Props = AgentsTreeItemPool & {
  searchQuery: string
  className?: string | undefined
  style?: KeyValue<string, string | number>
}
export default React.memo(function AgentPool({
  id,
  title,
  className,
  style,
  searchQuery,
  matching,
}: Props) {
  const tail = (
    <>
      {id != null && (
        <AgentPoolFavoriteStar
          className={classNames(styles.iconAction)}
          iconWrapperClassName={classNames(styles.starIcon)}
          id={id}
        />
      )}
    </>
  )
  return (
    <InactiveSidebarLink
      className={className}
      style={style}
      tail={tail}
      tabIndex={-1}
      aria-label={title}
    >
      {matching === true ? <MatchingItem searchQuery={searchQuery}>{title}</MatchingItem> : title}
    </InactiveSidebarLink>
  )
})
